import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ChannelManagerGuard } from '../guards/channel-manager.guard';
import { legalAdminGuard } from '../guards/legal-admin.guard';
import { sFDCAdminGuard } from '../guards/sfdcadmin.guard';
import { webAdminGuard } from '../guards/web-admin.guard';

export const CommonLayout_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full',
  },

  {
    path: 'global',
    loadChildren: () =>
      import('../../global/global.module').then((m) => m.GlobalModule),
    canActivate: [MsalGuard],
  },
  {
    path: 'pqi-jobs',
    loadChildren: () =>
      import('../../pqi-jobs/pqi-jobs.module').then((m) => m.PqiJobsModule),
    canActivate: [MsalGuard],
  },
  {
    path: 'landing',
    loadChildren: () =>
      import('../../application-home/application-home.module').then(
        (m) => m.ApplicationHomeModule
      ),
    canActivate: [MsalGuard],
  },

  {
    path: 'pqi-hub',
    loadChildren: () =>
      import('../../pqi-hub/pqi-hub.module').then((m) => m.PqiHubModule),

    canActivate: [MsalGuard],
  },
  {
    path: 'pqi-abr',
    loadChildren: () =>
      import('../../pqi-abr/pqi-abr.module').then((m) => m.PqiAbrModule),
    canActivate: [MsalGuard],
  },
  {
    path: 'sfdc-sync',
    loadChildren: () =>
      import('../../sfdc-sync/sfdc-sync-routing.module').then(
        (m) => m.SfdcSyncRoutingModule
      ),
    canActivate: [MsalGuard],
  },
  {
    path: 'vj-marketing',
    loadChildren: () =>
      import('../../vj-offices/vjweb-routing.module').then(
        (m) => m.VjwebRoutingModule
      ),
    canActivate: [MsalGuard],
  },
  {
    path: 'pqi-admin',
    loadChildren: () =>
      import('../../pqi-admin/auth-routing.module').then(
        (m) => m.AuthRoutingModule
      ),
    canActivate: [MsalGuard],
  },
];
